import React, { useMemo } from 'react';
import styles from './ChatHeader.module.scss';
import { useChatSidebar } from 'app-context/Chat-sidebar-context/ChatSidebarContext';
const navSvg = '/images/chat-navigator.svg';
const navSvgClosed = '/images/chat-navigator-closed.svg';

const ChatHeader = ({ title, selectedBot, isUserChat }) => {
  const { isOpen, toggle } = useChatSidebar();

  const initials = useMemo(() => {
    const name = (selectedBot?.botName || '').trim();
    if (!name) return 'BOT';

    const parts = name.split(/\s+/).filter(Boolean);
    const max = parts.length > 2 ? 3 : 2;

    return parts
      .slice(0, max)
      .map((w) => w.charAt(0).toUpperCase())
      .join('');
  }, [selectedBot?.botName]);

  return (
    <div className={styles.chatHeader}>
      <button
        type='button'
        className={styles.sidebarToggle}
        onClick={toggle}
        aria-label={isOpen ? 'Close sidebar' : 'Open sidebar'}
      >
        {isOpen ? (
          <img src={navSvg} alt='' />
        ) : (
          <img src={navSvgClosed} alt='' />
        )}
      </button>

      <div className={styles.left}>
        {!isUserChat && (
          <div className={styles.bot}>
            {selectedBot?.src ? (
              <img
                className={styles['bot-image']}
                src={selectedBot.src}
                alt=''
              />
            ) : (
              <div className={styles['bot-default']}>
                <p>{initials}</p>
              </div>
            )}
          </div>
        )}

        <div className={styles.description}>
          <h2 className={styles.title}>{selectedBot?.botName}</h2>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
